import { Autocomplete, FormControl, Skeleton, TextField } from '@mui/material';
import { useGetAllCategoriesQuery } from 'src/api/categories/getCategories';

interface Props {
  value: number;
  onChange: (event: any, newValue: number) => void;
  sport: string;
}

export const CategoryIdFormSelect = ({ value, onChange, sport }: Props) => {
  const { data: categories, isLoading, error } = useGetAllCategoriesQuery();

  if (isLoading) {
    return <Skeleton variant='rectangular' width={210} height={60} />;
  }

  if (error || !categories || categories.length === 0) {
    return <div>Can't load categories</div>;
  }

  return (
    <FormControl sx={{ width: '100%' }}>
      <Autocomplete
        sx={{ mt: 2 }}
        options={categories.filter((cat) => cat.languageCode === sport)}
        getOptionLabel={(option) =>
          `${option.id} -  ${option.name} [${option.difficulty}]`
        }
        getOptionKey={(option) => option.id}
        onChange={(event, option) => {
          onChange(event, option?.id || 0);
        }}
        value={categories.find((cat) => cat.id === value) || null}
        renderInput={(params) => <TextField {...params} label='Category' />}
      />
    </FormControl>
  );
};
